var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-page info-group" }, [
    _c("div", { staticClass: "application-form-height" }, [
      _c(
        "div",
        [
          _vm.physicalInfo
            ? _c(
                "van-form",
                { ref: "form" },
                [
                  _c(
                    "van-cell-group",
                    [
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "hospitalNameOfLastYear"
                          ),
                          label: "上一年体检医院",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "hospitalNameOfThisYear"
                          ),
                          label: "本年度预约体检医院",
                          readonly: "",
                          required: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm.amount || "--",
                          label: "所选医院体检额度",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button",
                              fn: function() {
                                return [_c("span", [_vm._v("元")])]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1347566867
                        )
                      })
                    ],
                    1
                  ),
                  _vm.physicalInfo && _vm.physicalInfo.hospitalNameOfThisYear
                    ? _c("hospital-files", {
                        attrs: { name: _vm.physicalInfo.hospitalNameOfThisYear }
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "buttons-panel" },
                    [
                      _c(
                        "van-button",
                        {
                          attrs: { type: "info", size: "large", plain: "" },
                          on: {
                            click: function($event) {
                              return _vm.$router.go(-1)
                            }
                          }
                        },
                        [_vm._v(" 返回 ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }